import { render, staticRenderFns } from "./ListCustomerCard.vue?vue&type=template&id=7f7f7baf&scoped=true&"
import script from "./ListCustomerCard.vue?vue&type=script&lang=js&"
export * from "./ListCustomerCard.vue?vue&type=script&lang=js&"
import style0 from "./ListCustomerCard.vue?vue&type=style&index=0&id=7f7f7baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7f7baf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VIcon,VList,VListItem,VListItemAvatar,VListItemContent,VListItemTitle})
